import { defineMessages } from 'react-intl';

export default defineMessages({
  type: 'Type',
  typePlaceholder: 'Select survey type',
  typeRequired: 'Please select a type',
  titleLabel: 'Title',
  titlePlaceholder: 'Survey title',
  titleRequired: 'Please enter a title',
  customerAliasLabel: 'Company display name',
  customerAliasTooltip: 'Company name displayed when answering the survey in disclaimer texts. Default is the customer alias or name.',
  languageLabel: 'Language',
  languagePlaceholder: 'Select survey language',
  languageRequired: 'Please select a language',
  advancedSettings: 'Advanced settings',
  categoriesLabel: 'Benchmark categories',
  categoriesPlaceholder: 'Select survey categories',
  showProgress: 'Show progress bar',
  enableClientPanel: 'Enable client panel',
  clientPanelTooltip: 'Enabling this will invite the respondents to participate in future surveys',
  keepOriginalResponses: 'Keep \'Original Text Responses\' after redacting',

  saveSuccess: 'Settings saved!',
  saveError: 'Failed to save settings. Please try again later',

  groupTitleLabel: 'Group title',
  groupTitlePlaceholder: 'Last survey in group if empty',
});
